import { render, staticRenderFns } from "./ClubPriceDetails.vue?vue&type=template&id=11c7be44&"
import script from "./ClubPriceDetails.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClubPriceDetails.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c7be44')) {
      api.createRecord('11c7be44', component.options)
    } else {
      api.reload('11c7be44', component.options)
    }
    module.hot.accept("./ClubPriceDetails.vue?vue&type=template&id=11c7be44&", function () {
      api.rerender('11c7be44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ClubPriceInfo.vue/components/ClubPriceDetails.vue"
export default component.exports